module.exports = __webpack_public_path__ + "img/flsmidth.b367a81b.jpg";